import { render, staticRenderFns } from "./ButMes.vue?vue&type=template&id=60136703&"
import script from "./ButMes.vue?vue&type=script&setup=true&lang=js&"
export * from "./ButMes.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ButMes.vue?vue&type=style&index=0&id=60136703&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports